import { Component } from '@angular/core';

@Component({
  selector: 'app-moreinfo-section',
  imports: [],
  templateUrl: './moreinfo-section.html',
  styleUrl: './moreinfo-section.css',
})
export class MoreinfoSection {}
